import { Download, Link2, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip } from '@/components/ui/tooltip';

type ShareExportRowProps = {
  onCopyShare: () => void | Promise<void>;
  onExportCsv: () => void | Promise<void>;
  onExportPdf: () => void | Promise<void>;
};

export function ShareExportRow({ onCopyShare, onExportCsv, onExportPdf }: ShareExportRowProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Tooltip content="Copy shareable URL with encoded calculator state">
        <Button variant="secondary" onClick={onCopyShare}>
          <Link2 className="h-4 w-4" />
          Copy Share Link
        </Button>
      </Tooltip>

      <Tooltip content="Export result table as comma-separated values">
        <Button variant="outline" onClick={onExportCsv}>
          <Download className="h-4 w-4" />
          Export CSV
        </Button>
      </Tooltip>

      <Tooltip content="Export formatted projection summary as PDF">
        <Button variant="outline" onClick={onExportPdf}>
          <FileText className="h-4 w-4" />
          Export PDF
        </Button>
      </Tooltip>
    </div>
  );
}
